module.exports = __webpack_public_path__ + "img/professional.d5be760b.png";